import {React, Accordion, AccordionPanel, _n} from 'pexui';
import {BasePage} from './base';
import {Button} from './comps/uicomps';
import {FilesList} from './docupload/files';
import {Html} from './comps/html';
import {flow} from '../models/flow';

export class ThankYouPage extends BasePage {
    constructor(props) {
        super(props);
    }

    hasHelp(){
        return false;
    }

    getFooterButtons(){
        return [{
            id: 'infw_btn_finish',
            className: 'infw-btn-primary',
            label: _n('thankyou.finish.label'),
            isPrimary: true,
            onClick:(evt)=>this.props.widget.onSubmit()
        }];
    }    

    renderContent(){
        const node = flow.getCurrentNode();        
        const panelTitle = _n(node.widgetOption.content_id + '.title', { business_name: node.account.organization_name});

        return [
               <div className="infw-message-wrapper">
                   <Html className="infw-message"
                        content="widget.message"
                   />
               </div>,
               <div className="infw-single-box" >
                   <div className="infw-accordion-header">
                       {panelTitle}
                   </div>
                   <FilesList files={node.files}
                              node={node}/>
                   <div className="pad-2"/>
               </div>
            ];
    }
}


// WEBPACK FOOTER //
// ./application/src/views/thank.jsx